import axios from 'axios';
import { API_URL } from '../../../../setup/config/env';
import { LIST_REQUEST, LIST_RESPONSE, LIST_DONE, GROUPS_RESPONSE } from './types';

export function getDocuments(params = {}) {
  return async dispatch => {
    dispatch({ type: LIST_REQUEST, isLoading: true });
    try {
      const { group, page, limit } = params;
      let queryParams = [];
      if (group) queryParams.push(`group=${group}`);
      if (page) queryParams.push(`page=${page}`);
      if (limit) queryParams.push(`limit=${limit}`);

      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
      const response = await axios.get(`${API_URL}/api/document${queryString}`);
      const { data } = response;
      if (data.success) {
        dispatch({ 
          type: LIST_RESPONSE, 
          list: data.data.list || [], 
          count: data.data.count || 0 
        });
      }
      return response;
    } finally {
      dispatch({ type: LIST_DONE });
    }
  };
}

export function getDocumentGroups() {
  return async dispatch => {
    try {
      const response = await axios.get(`${API_URL}/api/document/groups`);
      const { data } = response;
      if (data && data.success && Array.isArray(data.data)) {
        dispatch({ type: GROUPS_RESPONSE, groups: data.data });
      }
      return response;
    } catch (error) {
      console.error("Error fetching groups:", error);
      throw error;
    }
  };
}
